import { render, staticRenderFns } from "./BqFilterSelect.vue?vue&type=template&id=20d90167&scoped=true&"
import script from "./BqFilterSelect.vue?vue&type=script&lang=js&"
export * from "./BqFilterSelect.vue?vue&type=script&lang=js&"
import style0 from "./BqFilterSelect.vue?vue&type=style&index=0&id=20d90167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d90167",
  null
  
)

export default component.exports